import styled from '@emotion/styled';

export default styled('div')`
  padding: 20px;
  background-color: red;
  border-radius: 10px;
`;
